import { selectUserContext } from 'core/userContext';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FullWidth } from 'ui/utility/fullWidth';
import { ModalContextProvider } from 'utils/contexts/modal';
import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';
import { Footer, Header, Table } from './components';
import { Modals, UnsavedChangesPrompt } from './components/modals';
import { SORTING_CONTEXT_INITIAL_STATE } from './constants';
import {
  DataQueryContextProvider,
  FieldArrayContextProvider,
  LinksFormProvider,
  SearchParamsContextProvider,
} from './contexts';

const Wrapper = styled(FullWidth)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  padding-right: ${spacing.layoutLRPadding};
  padding-bottom: ${spacing.x5};
  padding-left: ${spacing.layoutLRPadding};
`;

const LinkExpirationManagementContent = () => {
  const [shouldNavigate, setShouldNavigate] = useState(false);
  return (
    <>
      <Wrapper>
        <Header />
        <Table />
      </Wrapper>
      <Footer />
      <Modals setShouldNavigate={setShouldNavigate} />
      <UnsavedChangesPrompt shouldNavigate={shouldNavigate} />
    </>
  );
};

export const LinkExpirationManagementPage = () => {
  const { featureFlags = {}, orgAdmin } = useSelector(selectUserContext);
  const shouldShowPage = Boolean(orgAdmin && featureFlags?.LinkExpirationManagement);

  return (
    <>
      {shouldShowPage && (
        <DataQueryContextProvider isOrgAdmin={Boolean(orgAdmin)}>
          <PaginationContextProvider>
            <SortingContextProvider
              defaultSortField={SORTING_CONTEXT_INITIAL_STATE.sortBy}
              defaultSortDirection={SORTING_CONTEXT_INITIAL_STATE.sortDirection}
            >
              <SearchParamsContextProvider>
                <ModalContextProvider>
                  <LinksFormProvider>
                    <FieldArrayContextProvider>
                      <LinkExpirationManagementContent />
                    </FieldArrayContextProvider>
                  </LinksFormProvider>
                </ModalContextProvider>
              </SearchParamsContextProvider>
            </SortingContextProvider>
          </PaginationContextProvider>
        </DataQueryContextProvider>
      )}
    </>
  );
};
